import { createSlice } from '@reduxjs/toolkit';
import { setOrganizationStatus } from '../actions';

export interface ActionPanelState {
  showPaymentWarning: boolean;
  dunningWarning: string | null;
}

const initialState: ActionPanelState = {
  showPaymentWarning: false,
  dunningWarning: null,
};

const actionPanelSlice = createSlice({
  name: 'actionPanel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setOrganizationStatus, (state, action) => {
      state.showPaymentWarning = action.payload.show_payment_warning;
      state.dunningWarning = action.payload.dunning_warning;
    });
  },
});

export const actionPanelReducer = actionPanelSlice.reducer;
